// extracted by mini-css-extract-plugin
module.exports = {"version":"body_version__QVCBv"};